<template>
  <div class="interest-confirmed__wrapper">
    <div class="interest-confirmed__image">
      <img src="@/assets/images/icon-confirmed.svg" alt="Confirm" />
    </div>
    <p class="interest-confirmed__title" data-testid="title">
      Thanks for registering your availability
    </p>
    <p class="interest-confirmed__text" data-testid="text-email">
      We’ll email you as soon as matching slots become available.
    </p>
    <p class="interest-confirmed__text" data-testid="text-availability">
      Your current availability is:
    </p>
    <div class="interest-confirmed__text">
      <p
        v-for="(slot, index) in availabilitySlots"
        :key="index"
        data-testid="availability-day"
      >
        {{ slot }}
      </p>
    </div>
    <p class="interest-confirmed__text" data-testid="text-links">
      To change this at any time, just visit the smart meter booking section in
      your online account.
    </p>

    <AppButton
      class="interest-confirmed__button"
      full-width
      :href="`${webSiteUrl}/energy/smart-meters`"
    >
      <span> Smart Meter Info </span>
    </AppButton>
    <AppButton
      class="interest-confirmed__button"
      full-width
      variant="invertedPrimary"
      :href="`${webSiteUrl}/myaccount`"
    >
      <span> Account Home </span>
    </AppButton>
  </div>
</template>

<script>
import AppButton from "@soenergy/frontend-library/src/components/AppButton.vue"

export default {
  components: { AppButton },
  data() {
    return { webSiteUrl: process.env.VUE_APP_WEBSITE_URL }
  },
  computed: {
    availabilitySlots() {
      return this.$store.state.availabilitySlots
    },
  },
}
</script>

<style scoped lang="scss">
.interest-confirmed {
  &__image {
    width: 100%;
    text-align: center;
  }
  &__wrapper {
    align-items: center;
    margin: auto;

    @include md {
      width: $width-7;
    }
    @media (max-width: #{$screen-md-min - 1}) {
      margin: 0 $space-3 0 $space-3;
    }
  }

  &__title {
    font-size: $font-size-5;
    font-weight: $weight-medium;
    margin-bottom: $space-6;
    text-align: center;

    @include md {
      font-size: $font-size-6;
    }
  }
  &__text {
    font-size: $font-size-4;
    margin-top: $space-4;

    @include md {
      font-size: $font-size-5;
    }
  }
  &__button {
    font-size: $font-size-3;
    margin-top: $space-5;

    @include md {
      font-size: $font-size-4;
    }
  }
}
</style>
